export default {"src":"/_next/static/media/0x0eC9F76202a7061eB9b3a7D6B59D36215A7e37da.cbf21dc1.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};